import { fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { WEEKPROGRAMFLYER_DEFAULT } from '../../constants/state';
import { addItemToArray, deleteItemFromArray, returnStateIfNoAction } from '../helpers';


const getInitState = weeks => {
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        weeks: weeks,
        customPeriodActive: false,
        currentWeek: weeks[1],
        ... WEEKPROGRAMFLYER_DEFAULT
    })
}

const onGet = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

const onGetSuccess = (state, action) => {
    const { weekProgramFlyer } = action.payload

    delete  weekProgramFlyer.status
    delete weekProgramFlyer.error

    return fromJS({
        status: requestStatus.REQUEST_SUCCESS,
        error: '',
        ... weekProgramFlyer
    })
}

const onUpdateSuccess = (state, action) => {
    const { weekProgramFlyer } = action.payload

    return fromJS({
        ... weekProgramFlyer
    })
}

const onSuccess = (state, action) => state.set('status', requestStatus.REQUEST_SUCCESS)
                                          .set('error', '')


const onError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR)
                                        .setIn(['error'], action.payload.errorMessage)


const onReset = (state) => state.set('status', requestStatus.INITIALIZED)
                                .set('error', null)


const addWeekProgramFlyerDate = (state, action) => {
    const { item, edited } = action.payload
    const keyArray = ['dateSettings']
    const stateSetEdited = state.setIn(['edited'], edited)
    const stateWithItem = stateSetEdited.setIn([...keyArray, ...[ 'items', item.id]], item)

    keyArray.push('order')

    return addItemToArray(stateWithItem, keyArray, item.id)
}

const updateWeekProgramFlyerDate = (state, action) => {
    const { item } = action.payload

    return state.setIn(['dateSettings', 'items', item.id], item)
}

const deleteWeekProgramFlyerDate = (state, action) => {
    const { itemId } = action.payload
    const keyArray = ['dateSettings']
    const stateSetEdited = state.setIn(['edited'], true)
    const stateWithoutItem = stateSetEdited.deleteIn([...keyArray, ...[ 'items', itemId]])

    keyArray.push('order')

    return deleteItemFromArray(stateWithoutItem, keyArray,  itemId)
}

const deleteAllWeekProgramFlyerDate = (state, action) => {
    const stateSetEdited = state.setIn(['edited'], true)
    const stateEmptyItems = stateSetEdited.setIn(['dateSettings', 'items'], {})

    return stateEmptyItems.setIn(['dateSettings', 'order'], [])
}

const updateWeekProgramFlyerSettings = (state, action) => {
    const {payload} = action.payload

    return state.setIn(["weekProgramFlyerSettings"], payload)
}

const updateWeekProgramFlyerOrder = (state, action) => {
    const { order, type } = action.payload
    
    return state.setIn([type, 'order'], order)
}

const addWeekProgramFlyerMovie = (state, action) => {
    const { item, edited } = action.payload
    const keyArray = ['choosenMovies']
    const stateSetEdited = state.setIn(['edited'], edited)
    const stateWithItem = stateSetEdited.setIn([...keyArray, ...[ 'items', item.id]], item)

    keyArray.push('order')

    return addItemToArray(stateWithItem, keyArray, item.id)
}

const bulkAddWeekProgramFlyerMovie = (state, action) => {
    const { items, order, edited } = action.payload
    const stateSetEdited = state.setIn(['edited'], edited)
    const stateWithItems = stateSetEdited.setIn(['choosenMovies', 'items'], items)

    return stateWithItems.setIn(['choosenMovies', 'order'], order)
}

const deleteWeekProgramFlyerMovie = (state, action) => {
    const { itemId } = action.payload
    const keyArray = ['choosenMovies']
    const stateSetEdited = state.setIn(['edited'], true)
    const stateWithoutItem = stateSetEdited.deleteIn([...keyArray, ...[ 'items', itemId]])

    keyArray.push('order')

    return deleteItemFromArray(stateWithoutItem, keyArray,  itemId)
}

const weekProgramFlyerReducer = weeks => (state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PRINT_DATA_GET_REQUEST:
        case actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_REQUEST:
            return onGet(state);
        case actionTypes.PRINT_DATA_GET_SUCCESS:
            return onGetSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_UPDATE_SUCCESS:
            return onUpdateSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_SUCCESS:
            return onSuccess(state)
        case actionTypes.PRINT_DATA_GET_ERROR:
        case actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_ERROR:
            return onError(state, action);
        case actionTypes.PRINT_DATA_WEEKPROGRAMFLYER_PDF_RESET:
            return onReset(state)

        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_CURRENT_WEEK:
            return state.set('currentWeek', action.payload.week).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_DATE_SETTINGS:
            return addWeekProgramFlyerDate(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_DATE_SETTINGS:
            return updateWeekProgramFlyerDate(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_DATE_SETTINGS:
            return deleteWeekProgramFlyerDate(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_ALL_DATE_SETTINGS:
            return deleteAllWeekProgramFlyerDate(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_SETTINGS:
            return updateWeekProgramFlyerSettings(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_SET_CUSTOM_PERIOD_ACTIVE:
            return state.set('customPeriodActive', action.payload.active).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_UPDATE_WEEKPROGRAMFLYER_ORDER:
            return updateWeekProgramFlyerOrder(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_ADD_WEEKPROGRAMFLYER_ELEMENT:
            return addWeekProgramFlyerMovie(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_BULK_ADD_WEEKPROGRAMFLYER_ELEMENT:
            return bulkAddWeekProgramFlyerMovie(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_WEEKPROGRAMFLYER_DELETE_WEEKPROGRAMFLYER_ELEMENT:
            return deleteWeekProgramFlyerMovie(state, action).set('hasChanges', true);
        default:
            return state;
    }
}


export default weekProgramFlyerReducer;